import React from "react";
import { Box, Typography, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowIcon } from "../../assets/icons";
import { useMediaQuery } from "@react-hook/media-query";

const DesktopCard = styled(Box)`
  background: var(--primary-lighter);
  border-radius: 16px;
  border: 1px solid #e2ede6;
  box-shadow: 0 2px 0 0 #e2ede6;
  min-width: 320px;
  width: 320px;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  @media (min-width: 900px) {
    min-width: 380px;
    width: 380px;
  }

  &:hover {
    border-color: var(--primary-default);
    box-shadow: 0 2px 0 0 var(--primary-default);
  }
`;

const MobileCard = styled(Box)`
  background: var(--primary-lighter);
  border-radius: 16px;
  border: 1px solid #e2ede6;
  box-shadow: 0 2px 0 0 #e2ede6;
  width: 85vw;
  min-width: 85vw;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    border-color: var(--primary-default);
    box-shadow: 0px 4px 16px 0px rgba(41, 188, 98, 0.15);
  }
`;

export const BrowseAllPlansCard: React.FC = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const mobile = useMediaQuery("only screen and (max-width: 600px)");
  const isRTL = i18n.language === "ar";
  const handleClick = () => {
    navigate("/all-plans");
  };

  const CardWrapper = mobile ? MobileCard : DesktopCard;

  return (
    <CardWrapper onClick={handleClick}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: { xs: "12px", md: "16px" },
          textAlign: "center",
          maxWidth: "100%",
        }}
      >
        {/* Title */}
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: 600,
            fontSize: { xs: "24px", md: "28px" },
            lineHeight: "normal",
            color: "var(--primary-dark)",
            whiteSpace: "normal",
          }}
        >
          {t("common.mealsSection.browseAllPlans.title")}
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: { xs: "16px", md: "18px" },
            lineHeight: { xs: "24px", md: "26px" },
            color: "var(--font-darkest)",
            whiteSpace: "normal",
            maxWidth: "100%",
          }}
        >
          {t("common.mealsSection.browseAllPlans.description")}
        </Typography>

        {/* Arrow Icon */}
        <Box
          className="arrow-icon"
          sx={{
            width: { xs: "56px", md: "64px" },
            height: { xs: "56px", md: "64px" },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "var(--primary-dark)",
            transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            transform: isRTL ? "none" : "rotate(180deg)",
            "& svg": {
              width: "100%",
              height: "100%",
              fill: "var(--primary-dark)",
            },
          }}
        >
          <ArrowIcon />
        </Box>
      </Box>
    </CardWrapper>
  );
};
